import { useQuery } from '@tanstack/react-query';

import PlansTable from '@/components/table/configureApp/plans/plansTable';
import { mapConfigPlans } from '@/components/utils/utils';
import { PlanItem } from '@/interfaces/api/configApp/IPlanItem';
import { haggleApiService } from '@/services/haggle.service';
import { notificationService } from '@/services/notification.service';

const ConfigurePlans = () => {
	const { data, isLoading, isError, error, refetch } = useQuery({
		queryKey: ['configPlans'],
		queryFn: () => haggleApiService.getPlans(),
		refetchOnWindowFocus: false,
	});

	if (isError && error instanceof Error) {
		notificationService.error(error.message);
	}

	const mappedPlans: PlanItem[] = mapConfigPlans(data?.data || {});

	return (
		<div
			className="flex flex-col justify-center items-center w-full"
			data-test="plans-config"
		>
			{isLoading && <div>Loading...</div>}

			{!isLoading && mappedPlans && (
				<PlansTable plans={mappedPlans} refetch={refetch} />
			)}
		</div>
	);
};

export default ConfigurePlans;
